<template>
  <div class="shell-page">
    <HeaderMain />

    <section class="legal-shell">
      <div class="glass-surface legal-card">
        <div class="section-heading">
          <span class="section-heading__eyebrow">Compras y soporte</span>
          <h1 class="section-heading__title">Reembolsos y cancelaciones</h1>
          <p class="section-heading__text">
            Esta politica explica como se gestionan cancelaciones, reprogramaciones, errores de compra y solicitudes relacionadas con Fomo Safe.
          </p>
        </div>

        <div class="legal-card__content">
          <section class="legal-page__highlight">
            <span class="legal-page__pill">Politica publica</span>
            <h2 class="legal-page__highlight-title">Politica publicada por GINGO ENTERPRISES LLC para FOMOPLANES</h2>
            <p>
              FOMOPLANES es operado por GINGO ENTERPRISES LLC, con direccion comercial registrada en 1209 MOUNTAIN ROAD PL NE STE R, ALBUQUERQUE, NM 87110, Estados Unidos.
            </p>
            <p>
              La responsabilidad principal sobre cancelaciones, reprogramaciones y autorizaciones de devolucion recae en el organizador del evento. GINGO ENTERPRISES LLC no es responsable por esas decisiones ni por su ejecucion, salvo que indique expresamente otra condicion.
            </p>
          </section>

          <section class="legal-page__section">
            <h2>1. Compras confirmadas</h2>
            <p>
              Antes de pagar, el comprador debe revisar fecha, funcion, localidad, cantidad de entradas, datos del asistente y cualquier condicion especial del evento. Las compras confirmadas no admiten cambios, devoluciones ni reembolsos por errores del comprador.
            </p>
          </section>

          <section class="legal-page__section">
            <h2>2. Fees y cargos operativos</h2>
            <p>
              Los fees de servicio, cargos de procesamiento y valores operativos aceptados durante el checkout no son reembolsables, salvo que la ley aplicable o una autorizacion expresa del organizador dispongan algo distinto.
            </p>
          </section>

          <section class="legal-page__section">
            <h2>3. Cancelaciones y reprogramaciones</h2>
            <p>
              Si un evento se cancela de forma oficial, la responsabilidad sobre la cancelacion, el reembolso, el credito o cualquier instruccion operativa recae en el organizador del evento. GINGO ENTERPRISES LLC no es responsable por esa cancelacion ni por la decision final del organizador, aunque puede colaborar con la gestion cuando exista autorizacion previa y segun las condiciones del procesador de pago correspondiente.
            </p>
            <p>
              Si un evento se reprograma, la validez de la entrada, las opciones de uso o cualquier reembolso dependeran exclusivamente de la politica informada para ese evento y de la autorizacion del organizador. GINGO ENTERPRISES LLC no es responsable por la reprogramacion ni por cambios operativos definidos por terceros.
            </p>
          </section>

          <section class="legal-page__section">
            <h2>4. Fomo Safe</h2>
            <p>
              Si agregaste Fomo Safe durante el checkout, su valor se cobra como addon independiente. Fomo Safe puede cubrir compras elegibles por imprevistos personales validables o por cancelacion oficial del evento, segun revision documental y validacion interna.
            </p>
            <p>
              Fomo Safe no cubre reprogramaciones, cambios de horario, cambios de venue, errores de compra, fees ya aceptados, decisiones operativas distintas de una cancelacion formal ni el valor del propio addon. Toda solicitud queda sujeta a validacion interna de GINGO ENTERPRISES LLC.
            </p>
          </section>

          <section class="legal-page__section">
            <h2>5. Como solicitar ayuda</h2>
            <p>
              Para revisar una incidencia escribe a <a class="legal-page__text-link" href="mailto:fomoplanes@sudenec.com">fomoplanes@sudenec.com</a> desde el correo asociado a tu compra e incluye nombre completo, evento, numero de orden, motivo de la solicitud y cualquier respaldo relevante.
            </p>
          </section>

          <div class="legal-page__actions">
            <router-link :to="{ name: 'terms' }">Terminos y condiciones</router-link>
            <router-link :to="{ name: 'privacy' }">Politica de privacidad</router-link>
            <router-link :to="{ name: 'contact' }">Contacto</router-link>
            <router-link :to="{ name: 'company' }">Compania</router-link>
          </div>
        </div>
      </div>
    </section>

    <FooterMain />
  </div>
</template>

<script>
import HeaderMain from '@/components/HeaderMain.vue'
import FooterMain from '@/components/FooterMain.vue'

export default {
  name: 'RefundsView',

  components: {
    HeaderMain,
    FooterMain,
  },
}
</script>

<style>
</style>
